export default __webpack_public_path__ + "static/media/main-background.cec03deb.webp";